import { domPropsSelector } from './ResponsiveTable';
import { useResponsiveTableContext } from './ResponsiveTableContext';
import { useDomProps } from './store/selection/useDomProps';

export const SeparatorCell = ({
  colSpan,
  rowIndex,
}: {
  colSpan: number;
  rowIndex: number;
}) => {
  const { name } = useResponsiveTableContext();
  const domProps = useDomProps(
    'separator',
    { rowIndex },
    domPropsSelector(name),
  );
  return (
    <td className="row__separator__cell" colSpan={colSpan} {...domProps} />
  );
};
